import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ArraysSlicesDemo = () => {
  const [activeTab, setActiveTab] = useState('array');
  const [output, setOutput]     = useState('');

  const tabs = [
    { key: 'array',       label: 'Массив' },
    { key: 'sliceCreate', label: 'Создать срез' },
    { key: 'sliceAppend', label: 'append' },
    { key: 'sliceCap',    label: 'len / cap' },
  ];

  const examples = {
    array: {
      code: `// Массив фиксированного размера
var numbers = [3]int{10,20,30}
// Изменим элемент и выведем
numbers[1] = 25
fmt.Println(numbers) // [10 25 30]`,
      run: () => setOutput('[10 25 30]'),
    },
    sliceCreate: {
      code: `// Создание среза из массива
array := [5]int{1,2,3,4,5}
slice := array[1:4]
fmt.Println(slice) // [2 3 4]`,
      run: () => setOutput('[2 3 4]'),
    },
    sliceAppend: {
      code: `// Добавление элементов в срез
slice := []int{1,2,3}
slice = append(slice,4,5)
fmt.Println(slice) // [1 2 3 4 5]`,
      run: () => setOutput('[1 2 3 4 5]'),
    },
    sliceCap: {
      code: `// Длина и вместимость
slice := []int{1,2,3,4,5}
fmt.Println(len(slice)) // 5
fmt.Println(cap(slice)) // 5`,
      run: () => setOutput('len=5 cap=5'),
    },
  };

  const { code, run } = examples[activeTab];

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Пример: Массивы и срезы в Go</h3>
      <div style={styles.tabList}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => { setActiveTab(tab.key); setOutput(''); }}
            style={activeTab === tab.key ? styles.activeTab : styles.tab}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <pre style={styles.codeBlock}><code>{code}</code></pre>
      <button onClick={run} style={styles.runButton}>Выполнить</button>
      {output && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          style={styles.output}
        >
          <strong>Результат:</strong> {output}
        </motion.div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: 700,
    margin: '2rem auto',
    padding: '1rem',
    background: '#fff',
    borderRadius: 12,
    border: '2px solid black',
  },
  title: {
    textAlign: 'center',
    marginBottom: '1rem',
  },
  tabList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'center',
    marginBottom: '1rem',
  },
  tab: {
    padding: '0.5rem 1rem',
    border: '1px solid #ccc',
    borderRadius: 6,
    background: '#f0f0f0',
    cursor: 'pointer',
  },
  activeTab: {
    padding: '0.5rem 1rem',
    border: '1px solid black',
    borderRadius: 6,
    background: 'black',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace',
    
  },
  codeBlock: {
    background: '#f5f5f5',
    padding: '1rem',
    borderRadius: 6,
    overflowX: 'auto',
  },
  runButton: {
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    border: 'none',
    borderRadius: 6,
    background: 'black',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace',
  },
  output: {
    marginTop: '1rem',
    padding: '0.75rem',
    background: '#f5f5f5',
    borderRadius: 6,
    fontFamily: 'monospace',
  },
};

export default ArraysSlicesDemo;